<div class="relative" data-date-picker>
  <div
    #triggerButton
    class="flex w-full items-center rounded-[6px] border border-slate300 bg-slate50 px-3.5 text-sm transition"
    [ngClass]="{
      'h-9': size === 'sm',
      'h-10': size === 'md',
      'h-[46px]': size === 'lg',
      'cursor-not-allowed opacity-70': control?.disabled || startControl?.disabled
    }">
 
    <ng-container *ngIf="mode === 'single'">
      <input
        type="text"
        class="min-w-0 flex-1 bg-transparent text-sm outline-none"
        [ngClass]="(control?.value || rawSingle) ? 'text-slate900' : 'text-slate400'"
        [placeholder]="placeholder"
        [disabled]="!!control?.disabled"
        [value]="singleFocused ? rawSingle : (control?.value ? formatDisplay(control?.value) : '')"
        (focus)="onSingleFocus()"
        (input)="onSingleInput($event)"
        (blur)="onSingleBlur($any($event.target).value)"
      />
    </ng-container>
 
    <ng-container *ngIf="mode === 'range'">
      <input
        type="text"
        class="min-w-0 flex-1 bg-transparent text-sm outline-none"
        [ngClass]="(startControl?.value || rawStart) ? 'text-slate900' : 'text-slate400'"
        placeholder="dd-mm-yyyy"
        [disabled]="!!startControl?.disabled"
        [value]="startFocused ? rawStart : (startControl?.value ? formatDisplay(startControl?.value) : '')"
        (focus)="onStartFocus()"
        (input)="onStartInput($event)"
        (blur)="onStartBlur($any($event.target).value)"
      />
      <span class="shrink-0 px-1 text-slate400">–</span>
      <input
        type="text"
        class="min-w-0 flex-1 bg-transparent text-sm outline-none"
        [ngClass]="(endControl?.value || rawEnd) ? 'text-slate900' : 'text-slate400'"
        placeholder="dd-mm-yyyy"
        [disabled]="!!startControl?.disabled"
        [value]="endFocused ? rawEnd : (endControl?.value ? formatDisplay(endControl?.value) : '')"
        (focus)="onEndFocus()"
        (input)="onEndInput($event)"
        (blur)="onEndBlur($any($event.target).value)"
      />
    </ng-container>
 
    <button type="button" (click)="toggle()" class="ml-2 shrink-0 text-slate500">
      <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.6665 0.832031C7.12674 0.832031 7.49984 1.20513 7.49984 1.66536V2.4987H12.4998V1.66536C12.4998 1.20513 12.8729 0.832031 13.3332 0.832031C13.7934 0.832031 14.1665 1.20513 14.1665 1.66536V2.4987H14.9998C16.8408 2.4987 18.3332 3.99108 18.3332 5.83203V14.9987C18.3332 16.8396 16.8408 18.332 14.9998 18.332H4.99984C3.15889 18.332 1.6665 16.8396 1.6665 14.9987V5.83203C1.6665 3.99108 3.15889 2.4987 4.99984 2.4987H5.83317V1.66536C5.83317 1.20513 6.20627 0.832031 6.6665 0.832031ZM12.4998 4.16536C12.4998 4.6256 12.8729 4.9987 13.3332 4.9987C13.7934 4.9987 14.1665 4.6256 14.1665 4.16536H14.9998C15.9203 4.16536 16.6665 4.91156 16.6665 5.83203V6.2487H3.33317V5.83203C3.33317 4.91156 4.07936 4.16536 4.99984 4.16536H5.83317C5.83317 4.6256 6.20627 4.9987 6.6665 4.9987C7.12674 4.9987 7.49984 4.6256 7.49984 4.16536H12.4998ZM16.6665 7.91536H3.33317V14.9987C3.33317 15.9192 4.07936 16.6654 4.99984 16.6654H14.9998C15.9203 16.6654 16.6665 15.9192 16.6665 14.9987V7.91536Z" fill="#475569"/>
      </svg>
    </button>
  </div>
 
  <div
    *ngIf="isOpen"
    class="z-[9999] overflow-hidden rounded-[8px] border border-slate300 bg-white shadow-[0_6px_16px_rgba(15,23,42,0.18)]"
    [ngStyle]="overlayStyle"
  >
    <div class="p-3">
      <div class="mb-3 flex items-center justify-between px-1">
        <button type="button" (click)="prevMonth('left')" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50">‹</button>
 
        <div class="flex items-center gap-2">
          <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onMonthChange('left',$any($event.target).value)">
            <option *ngFor="let m of monthOptions" [value]="m.value" [selected]="m.value === leftMonth.getMonth()">{{ m.label }}</option>
          </select>
 
          <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onYearChange('left',$any($event.target).value)">
            <option *ngFor="let y of yearOptions" [value]="y" [selected]="y === leftMonth.getFullYear()">{{ y }}</option>
          </select>
        </div>
 
        <button type="button" (click)="nextMonth('left')" [disabled]="isNextMonthDisabled(leftMonth)" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50 disabled:cursor-not-allowed disabled:opacity-30">›</button>
      </div>
 
      <div class="mb-2 grid grid-cols-7 gap-y-2">
        <span *ngFor="let d of weekDays" class="text-center text-sm font-semibold text-slate700">{{ d }}</span>
      </div>
 
      <div class="grid grid-cols-7 gap-y-1">
        <button *ngFor="let day of getCalendarDays(leftMonth)" type="button" (click)="selectDate(day.iso)" [disabled]="isDateDisabled(day.iso)" class="mx-auto inline-flex h-9 w-9 items-center justify-center rounded-full" [ngClass]="{ 'text-slate400 opacity-70': !day.inCurrentMonth && !isSelected(day.iso), 'text-slate700': day.inCurrentMonth && !isSelected(day.iso) && !isDateDisabled(day.iso), 'bg-slate200 text-slate900': isSelected(day.iso), 'cursor-not-allowed !text-slate300 opacity-40': isDateDisabled(day.iso) }">{{ day.day }}</button>
      </div>
 
      <div *ngIf="mode === 'range'" class="mt-3">
        <div class="mb-3 flex items-center justify-between px-1">
          <button type="button" (click)="prevMonth('right')" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50">‹</button>
 
          <div class="flex items-center gap-2">
            <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onMonthChange('right',$any($event.target).value)">
              <option *ngFor="let m of monthOptions" [value]="m.value" [selected]="m.value === rightMonth.getMonth()">{{ m.label }}</option>
            </select>
 
            <select class="h-8 rounded-md border border-slate300 bg-white px-2 text-xs text-slate700 outline-none" (change)="onYearChange('right',$any($event.target).value)">
              <option *ngFor="let y of yearOptions" [value]="y" [selected]="y === rightMonth.getFullYear()">{{ y }}</option>
            </select>
          </div>
 
          <button type="button" (click)="nextMonth('right')" [disabled]="isNextMonthDisabled(rightMonth)" class="inline-flex h-7 w-7 items-center justify-center rounded-full text-slate500 hover:bg-slate50 disabled:cursor-not-allowed disabled:opacity-30">›</button>
        </div>
 
        <div class="mb-2 grid grid-cols-7 gap-y-2">
          <span *ngFor="let d of weekDays" class="text-center text-sm font-semibold text-slate700">{{ d }}</span>
        </div>
 
        <div class="grid grid-cols-7 gap-y-1">
          <button *ngFor="let day of getCalendarDays(rightMonth)" type="button" (click)="selectDate(day.iso)" [disabled]="isDateDisabled(day.iso)" class="mx-auto inline-flex h-9 w-9 items-center justify-center rounded-full" [ngClass]="{ 'text-slate400 opacity-70': !day.inCurrentMonth && !isSelected(day.iso), 'text-slate700': day.inCurrentMonth && !isSelected(day.iso) && !isDateDisabled(day.iso), 'bg-slate200 text-slate900': isSelected(day.iso), 'bg-indigo100 text-indigo700': isInRange(day.iso), 'cursor-not-allowed !text-slate300 opacity-40': isDateDisabled(day.iso) }">{{ day.day }}</button>
        </div>
 
        <div class="mt-3 flex items-center justify-between">
          <button type="button" class="text-sm text-slate500" (click)="clearRange($event)">Clear</button>
          <div class="text-xs text-slate500">Select start and end dates</div>
        </div>
      </div>
    </div>
  </div>
</div>